<template>
    <div class="card">
        <div class="card-header">Applicant Affirmation</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    The information I have provided in this application is true and accurate to the best of my knowledge.
                    I have read and will comply with the requirements of Minnesota Statutes, Chapter 146B. I understand that knowingly
                    making a false statement on this application could be cause for denial, suspension or revocation of certification.
                    I understand by signing this document, I give MDH the authority to contact any listed supervisor, employer or client
                    submitted for use in verification of credentials.
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="6">
                    <BaseTextInput v-model="affirm.signature"
                                   :v="$v.affirm.signature"
                                   slug="signature"
                                   label="Signature"
                                   setId="sig"/>
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseDateInput v-model="affirm.dateSigned"
                                   :v="$v.affirm.dateSigned"
                                   label="Date"
                                   slug="dateSigned"
                                   :disabled="true"
                                   setId="dtSig"
                                   tip="Format: MM/DD/YYYY"
                    />
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import BaseTextInput from "@/components/templates/input/BaseTextInput"
    import BaseDateInput from "@/components/templates/input/BaseDateInput"
    import { required } from 'vuelidate/lib/validators'

export default {
    components:{
        BaseDateInput,
        BaseTextInput
    },
    data(){
        return {
            affirm: {
                signature: null,
                dateSigned: new Date().toISOString()
            }
        }
    },
    validations(){
        return{
            affirm: {
                signature: {required},
                dateSigned: {required},
            },
            form:['affirm']
        }
    },
    methods:{
        validate(){
            this.$v.form.$touch();
            let isValid = !this.$v.form.$invalid;
            this.$emit('on-validate', this.$data, isValid);
            return isValid;
        },
    },
}
</script>